<template>
  <BasePage>
    <ViewLoader :status="loaderStatus"/>
    <ContentMissing v-if="status === 'error'"/>
    <div v-else-if="status === 'complete' && !invalidData">
      <component
        v-for="(item,n) in componentList"
        v-bind="item"
        :key="n"
        :is="item.component"
        :renderIndex="n"
      />
    </div>
  </BasePage>
</template>
<script>
import ApiMixin from '@/mixins/ApiMixin'
export default {
  name: 'ViewBase',
  mixins: [ApiMixin]
}
</script>



// WEBPACK FOOTER //
// src/components/ViewBase/ViewBase.vue